module.exports = __webpack_public_path__ + "img/苍南县教育局.9a52b90a.png";